const YOU_REG = /^\/?you\/?$/i;
const mehubHandler = (url) => {
  if (YOU_REG.test(url)) {
    return url.replace(YOU_REG, "/notification-center");
  }
  return null;
};
export {
  mehubHandler
};
